<<template>
    <div>
         <!-- ====== Team Start ====== -->
    <section id="team" class="ch-gw-team" style="padding-top:1rem;padding-bottom:2rem">
      <div class="container m_container ch-gw-animation">
        <div class="row">
          <div class="col-lg-12">
            
                <div class="" style="padding-bottom: 2rem;padding-top: 2rem;border-bottom: 1px solid rgba(0,0,0,0.1);width: 100%;" v-for="(item,index) in platformList">
                    <div style="width: 100%;" >
                        <p style="font-size: 1.2rem;font-weight: 600;color: rgb(4, 127, 214);">{{ item.titleValue }}</p>
                        <ul style="padding-left: 2rem;">
                            <li style="list-style-type:disc;padding-top: 1rem;" v-for="(itemSub,indexSub) in item.subtitleList">{{ itemSub.subtitleValue }}</li>
                        </ul>
                    </div>
                    <div style="width: 30%;margin: 0 auto;">
                       
                    </div>
                </div>
            
          </div>
        </div>
        
      </div>
      
    </section>
    <div style="width: 100%;display: flex;justify-content: center;padding-bottom:2rem">
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="pageCount"
            @current-change="pagesChange">
        </el-pagination>
    </div>
    </div>
</template>
<script>
import {queryPlatform } from "@/utils/gw";
export default {
  components:{

  },
  name: 'platform',
  data () {
    return {
      pageIndex:1,
      pageCount:0,
      pageSize:0,
      platformList:[]
    }
  },
  mounted() {
    this.queryPlatform()
  },
  methods:{
    pagesChange(v){
        console.log(v)
        this.pageIndex = v
        this.queryPlatform()
    },
    queryPlatform(){
        var u = "?pageIndex="+this.pageIndex
        queryPlatform(u).then((e)=>{
            this.pageCount = e.data.pageCount
            this.pageSize = e.data.pageSize
            this.platformList = e.data.platform
            console.log(e.data)
        })
    }
  }
}
</script>
<style>
    .newsImg{
        transition: 0.3s; 
        width: 100%;
        height: 100%;
    }
    .newsImg:hover {
        transition: 0.3s;
        transform: scale(1.1);
    }
    .newsTitle{
        color: rgb(0,0,0);
        transition: 0.3s; 
    }
    .newsTitle:hover{
        color: rgb(0, 195, 255);
        transition: 0.3s; 
    }
</style>



// WEBPACK FOOTER //
// src/components/about/platform.vue